import { createAsyncThunk } from '@reduxjs/toolkit';
import { _radiologistUser, _reportSettingsUrls } from '@custom/Utils/constants/apiUrls';
import { ReportSettingsFormObj } from '@custom/Utils/constants/interfaces';
import { getCloudPACSToken } from '@custom/Utils/authUtils';

export const assignRadiologistApi = createAsyncThunk<
  any,
  ReportSettingsFormObj
>(
  'assignRadiologistApi',
  async (obj, { rejectWithValue }) => {
    try {
      const pacs_token = getCloudPACSToken();
      const {studyInstanceUID, keyValueData} = obj;
      const response = await fetch(`${_radiologistUser.assign}/${studyInstanceUID}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${pacs_token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(keyValueData),
      });

      const data = await response.json();

      if (response.ok) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
